/**
 * Stockage actif pour l’onglet courant :
 * - Si un token existe dans sessionStorage → session de l’onglet (sans « se souvenir »).
 * - Sinon → localStorage (« se souvenir de moi »).
 *
 * Évite de mélanger deux comptes (ex. admin en local et finance en session) dans le même navigateur.
 */

export function getActiveToken() {
  const t = sessionStorage.getItem('token');
  if (t) return t;
  return localStorage.getItem('token');
}

export function getActiveUserRaw() {
  if (sessionStorage.getItem('token')) {
    return sessionStorage.getItem('user');
  }
  return localStorage.getItem('user');
}

/** Met à jour l’objet `user` dans le même stockage que le token actif. */
export function setActiveUserJson(userObj) {
  const str = JSON.stringify(userObj);
  if (sessionStorage.getItem('token')) {
    sessionStorage.setItem('user', str);
  } else {
    localStorage.setItem('user', str);
  }
}

function normalizeRoleFromParsed(parsed) {
  if (!parsed || typeof parsed !== 'object') return null;
  let r = parsed.role ?? parsed.Role ?? parsed.type;
  if (typeof r === 'string' && r.trim()) return r.trim().toLowerCase();
  if (Array.isArray(parsed.roles)) {
    const first = parsed.roles.find((x) => typeof x === 'string');
    if (first) return String(first).trim().toLowerCase();
  }
  if (typeof parsed.roles === 'string') return parsed.roles.trim().toLowerCase();
  return null;
}

/** Objet user lié au token actif. */
export function getActiveUser() {
  try {
    const raw = getActiveUserRaw();
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Rôle lié au token actif (menu latéral, contrôles d’accès côté UI). */
export function getActiveAuthRole() {
  try {
    const raw = getActiveUserRaw();
    if (raw) {
      const role = normalizeRoleFromParsed(JSON.parse(raw));
      if (role) return role;
    }
  } catch {
    /* ignore */
  }
  const direct = sessionStorage.getItem('token')
    ? sessionStorage.getItem('role') || sessionStorage.getItem('Role')
    : localStorage.getItem('role') || localStorage.getItem('Role');
  if (direct) return String(direct).trim().toLowerCase();
  return null;
}

/** Supprime token, user et rôles du navigateur (déconnexion / session expirée). */
export function clearAllAuthTokens() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("Role");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("Role");
  } catch {
    /* ignore */
  }
}
